export const linearIcons = '#003468';
// const linearIcons = 'linear-gradient(157deg, rgba(21,12,58,1) 0%, rgba(37,150,190,1) 48%, rgba(0,0,0,1) 100%, rgba(76,97,255,1) 100%)';
